//export const Domain_API = 'https://20.204.166.43/api/v1/';
// export const Dev_Domain = 'https://www.oldparrscotch.com/dev';
// export const Localhost_Domain = 'http://localhost:3001/';
export const Localhost_Domain = window.location.origin
